// extracted by mini-css-extract-plugin
export default {"StrollerDetailRating":"xj_a bhk_a bhk_x","StrollerDetailRating__muted":"xj_b bhk_fm"};